import { WebApi } from '../../services/WebApi'

const state = () => ({
  addingClientRegistration: false,
  clientRegistration: null,
  contractTemplate: null,
  loadingContractTemplate: false
})

const mutations = {
  setAdding (state, value) {
    state.addingClientRegistration = !!value
  },
  setClientRegistration (state, clientRegistration) {
    state.clientRegistration = clientRegistration
  },
  setContractTemplate (state, template) {
    state.contractTemplate = template
  },
  setLoadingContractTemplate (state, value) {
    state.loadingContractTemplate = !!value
  }
}

const actions = {
  addClientRegistration ({ commit }, { siteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setAdding', true)
      WebApi.post('Portal/' + siteId + '/ClientRegistration', payload)
        .then(response => {
          commit('setClientRegistration', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setAdding', false))
    })
  },
  fetchContractTemplate ({ commit }, { siteId }) {
    return new Promise((resolve, reject) => {
      commit('setLoadingContractTemplate', true)
      WebApi.get('Portal/' + siteId + '/ClientRegistration/ContractTemplate')
        .then(response => {
          commit('setContractTemplate', response.data || null)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoadingContractTemplate', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
